module.exports = __webpack_public_path__ + "img/seminole.1cf62c38.png";